import React from 'react';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary';
  fullWidth?: boolean;
}

export const Button: React.FC<ButtonProps> = ({
  children,
  variant = 'primary',
  fullWidth = false,
  disabled,
  className = '',
  ...props
}) => {
  const baseClasses = [
    'inline-flex items-center justify-center rounded-[14px] px-5 py-3 text-sm font-semibold transition-colors sm:text-base',
    'disabled:cursor-not-allowed disabled:opacity-60',
    fullWidth ? 'w-full' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  const variantClasses: Record<'primary' | 'secondary', string> = {
    primary:
      'bg-enpal-cta-yellow text-enpal-downriver hover:bg-enpal-sunshine-yellow',
    secondary:
      'border border-enpal-downriver/20 bg-white text-enpal-downriver hover:bg-slate-100',
  };

  return (
    <button
      className={`${baseClasses} ${variantClasses[variant]}`}
      disabled={disabled}
      {...props}
    >
      {children}
    </button>
  );
};

